// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChooseOptionsStepBody_PlanPackageQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
  rpavId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ChooseOptionsStepBody_PlanPackageQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, name: string, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, name: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type ChooseOptionsStepBody_GlobalOptionsQueryVariables = Types.Exact<{
  filter: Types.GlobalOptionsFilter;
}>;


export type ChooseOptionsStepBody_GlobalOptionsQuery = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, code: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, type: { __typename?: 'GlobalOptionType', allowsLocations: boolean, id: string, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> }> };

export type ChooseOptionsStepBody_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, name: string, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, name: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } }>, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ChooseOptionsStepBody_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, active: boolean, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, type: { __typename?: 'GlobalOptionType', id: string } };

export type ChooseOptionsStepBody_GlobalOptionFragment = { __typename?: 'GlobalOption', id: string, name: string, code: string, lastUsedAt?: Types.Scalars['DateTime']['input'] | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, type: { __typename?: 'GlobalOptionType', allowsLocations: boolean, id: string, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> };

export const ChooseOptionsStepBody_ReadyPlanOptionFragmentDoc = gql`
    fragment ChooseOptionsStepBody_ReadyPlanOption on ReadyPlanOption {
  id
  canDelete {
    ...PotentialOperationDetails
  }
  active
  readyPlanLocation {
    id
  }
  globalOption {
    id
  }
  type {
    id
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const ChooseOptionsStepBody_PlanPackageFragmentDoc = gql`
    fragment ChooseOptionsStepBody_PlanPackage on PlanPackage {
  id
  name
  roomLocations(filter: {locationType: [GROUP, ROOM, LEVEL]}) {
    ...Named
  }
  options {
    ...ChooseOptionsStepBody_ReadyPlanOption
  }
  canEdit {
    ...PotentialOperationDetails
  }
}
    ${NamedFragmentDoc}
${ChooseOptionsStepBody_ReadyPlanOptionFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const ChooseOptionsStepBody_GlobalOptionFragmentDoc = gql`
    fragment ChooseOptionsStepBody_GlobalOption on GlobalOption {
  id
  name
  code
  statusDetail {
    code
    name
  }
  type {
    ...Named
    allowsLocations
  }
  lastUsedAt
  updatedAt
  createdAt
  tags {
    id
    name
  }
}
    ${NamedFragmentDoc}`;
export const ChooseOptionsStepBody_PlanPackageDocument = gql`
    query ChooseOptionsStepBody_PlanPackage($planPackageId: ID!, $rpavId: ID) {
  planPackage(id: $planPackageId, versionId: $rpavId) {
    ...ChooseOptionsStepBody_PlanPackage
  }
}
    ${ChooseOptionsStepBody_PlanPackageFragmentDoc}`;

/**
 * __useChooseOptionsStepBody_PlanPackageQuery__
 *
 * To run a query within a React component, call `useChooseOptionsStepBody_PlanPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseOptionsStepBody_PlanPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseOptionsStepBody_PlanPackageQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useChooseOptionsStepBody_PlanPackageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables> & ({ variables: ChooseOptionsStepBody_PlanPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>(ChooseOptionsStepBody_PlanPackageDocument, options);
      }
export function useChooseOptionsStepBody_PlanPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>(ChooseOptionsStepBody_PlanPackageDocument, options);
        }
export function useChooseOptionsStepBody_PlanPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>(ChooseOptionsStepBody_PlanPackageDocument, options);
        }
export type ChooseOptionsStepBody_PlanPackageQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_PlanPackageQuery>;
export type ChooseOptionsStepBody_PlanPackageLazyQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_PlanPackageLazyQuery>;
export type ChooseOptionsStepBody_PlanPackageSuspenseQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_PlanPackageSuspenseQuery>;
export type ChooseOptionsStepBody_PlanPackageQueryResult = Apollo.QueryResult<ChooseOptionsStepBody_PlanPackageQuery, ChooseOptionsStepBody_PlanPackageQueryVariables>;
export const ChooseOptionsStepBody_GlobalOptionsDocument = gql`
    query ChooseOptionsStepBody_GlobalOptions($filter: GlobalOptionsFilter!) {
  globalOptions(filter: $filter) {
    ...ChooseOptionsStepBody_GlobalOption
  }
}
    ${ChooseOptionsStepBody_GlobalOptionFragmentDoc}`;

/**
 * __useChooseOptionsStepBody_GlobalOptionsQuery__
 *
 * To run a query within a React component, call `useChooseOptionsStepBody_GlobalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseOptionsStepBody_GlobalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseOptionsStepBody_GlobalOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChooseOptionsStepBody_GlobalOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables> & ({ variables: ChooseOptionsStepBody_GlobalOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>(ChooseOptionsStepBody_GlobalOptionsDocument, options);
      }
export function useChooseOptionsStepBody_GlobalOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>(ChooseOptionsStepBody_GlobalOptionsDocument, options);
        }
export function useChooseOptionsStepBody_GlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>(ChooseOptionsStepBody_GlobalOptionsDocument, options);
        }
export type ChooseOptionsStepBody_GlobalOptionsQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_GlobalOptionsQuery>;
export type ChooseOptionsStepBody_GlobalOptionsLazyQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_GlobalOptionsLazyQuery>;
export type ChooseOptionsStepBody_GlobalOptionsSuspenseQueryHookResult = ReturnType<typeof useChooseOptionsStepBody_GlobalOptionsSuspenseQuery>;
export type ChooseOptionsStepBody_GlobalOptionsQueryResult = Apollo.QueryResult<ChooseOptionsStepBody_GlobalOptionsQuery, ChooseOptionsStepBody_GlobalOptionsQueryVariables>;